import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["value"];
const _hoisted_2 = ["value"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'DateRangeSelecter',
    props: {
        startDate: {
            type: String,
            required: true,
        },
        endDate: {
            type: String,
            required: true,
        },
    },
    emits: ["update:start-date", "update:end-date"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const updateStartDate = (event) => {
            const target = event.target;
            const value = target ? target.value : "";
            emit("update:start-date", value);
        };
        const updateEndDate = (event) => {
            const target = event.target;
            const value = target ? target.value : "";
            emit("update:end-date", value);
        };
        const formatDate = (date) => {
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth() + 1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        };
        const setDateRange = (type) => {
            let firstDay;
            let lastDay;
            let baseDate;
            if (type === "thisMonth" || type === "thisWeek") {
                baseDate = new Date();
            }
            else if (props.startDate && !isNaN(new Date(props.startDate).getTime())) {
                baseDate = new Date(props.startDate);
            }
            else {
                baseDate = new Date();
            }
            let startYear = baseDate.getFullYear();
            let startMonth = baseDate.getMonth();
            let startDay = baseDate.getDate();
            switch (type) {
                // 月単位処理
                case "thisMonth":
                    firstDay = new Date(startYear, startMonth, 1);
                    lastDay = new Date(startYear, startMonth + 1, 0);
                    break;
                case "nextMonth":
                    firstDay = new Date(startYear, startMonth + 1, 1);
                    lastDay = new Date(startYear, startMonth + 2, 0);
                    break;
                case "prevMonth":
                    firstDay = new Date(startYear, startMonth - 1, 1);
                    lastDay = new Date(startYear, startMonth, 0);
                    break;
                // 週単位処理
                case "thisWeek":
                    let today = new Date();
                    let thisWeekStartDay = today.getDay() || 7; // 0を日曜として7とする
                    firstDay = new Date(today);
                    firstDay.setDate(today.getDate() - thisWeekStartDay + 1); // 週の初めを求める（月曜日）
                    lastDay = new Date(today);
                    lastDay.setDate(today.getDate() - thisWeekStartDay + 7); // 週の終わりを求める
                    break;
                case "nextWeek":
                    let nextWeekStartDay = baseDate.getDay() || 7;
                    firstDay = new Date(baseDate);
                    firstDay.setDate(startDay - nextWeekStartDay + 8); // 次の週の初めを求める
                    lastDay = new Date(baseDate);
                    lastDay.setDate(startDay - nextWeekStartDay + 14); // 次の週の終わりを求める
                    break;
                case "prevWeek":
                    let prevWeekStartDay = baseDate.getDay() || 7;
                    firstDay = new Date(baseDate);
                    firstDay.setDate(startDay - prevWeekStartDay - 6); // 前の週の初めを求める
                    lastDay = new Date(baseDate);
                    lastDay.setDate(startDay - prevWeekStartDay); // 前の週の終わりを求める
                    break;
            }
            // 日付をフォーマットして親に通知
            emit("update:start-date", formatDate(firstDay));
            emit("update:end-date", formatDate(lastDay));
        };
        return (_ctx, _cache) => {
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_col = _resolveComponent("v-col");
            return (_openBlock(), _createBlock(_component_v_col, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-space-between" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("input", {
                                        type: "date",
                                        value: __props.startDate,
                                        onInput: _cache[0] || (_cache[0] = ($event) => (updateStartDate($event))),
                                        placeholder: "開始日",
                                        class: ""
                                    }, null, 40, _hoisted_1),
                                    _createElementVNode("input", {
                                        type: "date",
                                        value: __props.endDate,
                                        onInput: _cache[1] || (_cache[1] = ($event) => (updateEndDate($event))),
                                        placeholder: "終了日"
                                    }, null, 40, _hoisted_2)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card, { class: "d-flex justify-space-around" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[2] || (_cache[2] = ($event) => (setDateRange('prevMonth')))
                                    }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode("前月")
                                        ])),
                                        _: 1,
                                        __: [8]
                                    }),
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[3] || (_cache[3] = ($event) => (setDateRange('thisMonth')))
                                    }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode("今月")
                                        ])),
                                        _: 1,
                                        __: [9]
                                    }),
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[4] || (_cache[4] = ($event) => (setDateRange('nextMonth')))
                                    }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("翌月")
                                        ])),
                                        _: 1,
                                        __: [10]
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[5] || (_cache[5] = ($event) => (setDateRange('prevWeek')))
                                    }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode("前週")
                                        ])),
                                        _: 1,
                                        __: [11]
                                    }),
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[6] || (_cache[6] = ($event) => (setDateRange('thisWeek')))
                                    }, {
                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("今週")
                                        ])),
                                        _: 1,
                                        __: [12]
                                    }),
                                    _createVNode(_component_v_btn, {
                                        onClick: _cache[7] || (_cache[7] = ($event) => (setDateRange('nextWeek')))
                                    }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode("翌週")
                                        ])),
                                        _: 1,
                                        __: [13]
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
